export default {
  computed: {
    stateProgramName: {
      get () {
        return this.program.name
      },

      set (value) {
        this.setProgramProperty({ property: 'name', value })
      }
    },
    stateProgramHelpUrl: {
      get () {
        return this.program.help_url
      },

      set (value) {
        this.setProgramProperty({ property: 'help_url', value })
      }
    },
    stateProgramOpenDate: {
      get () {
        return this.program.open_date
      },

      set (value) {
        this.setProgramProperty({ property: 'open_date', value })
      }
    },
    stateProgramDueDate: {
      get () {
        return this.program.due_date
      },

      set (value) {
        this.setProgramProperty({ property: 'due_date', value })
      }
    }
  }
}
